import React, { Component } from 'react';
import {
  FaPhone,
  FaRegEnvelope,
  FaMapMarkerAlt,
  FaExclamation,
  FaCheck,
  FaTimesCircle,
  FaClock,
} from 'react-icons/fa';
import ReCAPTCHA from 'react-google-recaptcha';
import { ContentWrapper } from '../../utils/components';
import '../../styles/Contact.css';
import LeafletMap from "./leafletMap";

const axios = require('axios').default;

class Contact extends Component {
  state = {
    name: '',
    firstName: '',
    tel: '',
    email: '',
    message: '',
    captcha: '',
    result: null,
  };


  onChangeTextField = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  submitForm = (e) => {
    e.preventDefault();
    const { name, firstName, tel, email, message, captcha } = this.state;

    if (!captcha) {
      alert('Gelieve de captcha in te vullen.');
      return;
    }

    this.setState({ result: null });

    axios
      .post('/php/send_contact.php', {
        name,
        firstName,
        tel,
        email,
        message,
        captcha,
      })
      .then((response) => {
        this.setState({ result: 200 });
      })
      .catch((error) => {
        this.setState({ result: 400 });
      });

    this.setState({
      name: '',
      firstName: '',
      tel: '',
      email: '',
      message: '',
      captcha: '',
    });
  };

  onChangeReCaptcha = (value) => {
    this.setState({ captcha: value });
  };

  render() {
    const { map } = this.props;
    const { name, firstName, tel, email, message, result } = this.state;

    return (
      <div>
        <LeafletMap />
        <div className="section contact-wrapper">
          <ContentWrapper>
            <h3 className="title contact-title">Contacteer ons</h3>
            <p className="contact-text">
              Gebruik dit contactformulier om ons snel te contacteren.
              We behandelen uw bericht zo snel mogelijk en bezorgen u een gepast antwoord.
            </p>
            <div className="contact-flex-layout">
              {/* Formulier */}
              <div className="contact-form-container">
                {result === 200 && (
                  <div className="success">
                    <FaCheck />
                    <span>Uw bericht is succesvol verzonden. We nemen spoedig contact met u op.</span>
                  </div>
                )}
                {result === 400 && (
                  <div className="error">
                    <FaTimesCircle />
                    <span>Er is iets misgegaan. Probeer het later opnieuw.</span>
                  </div>
                )}
                <form onSubmit={this.submitForm}>
                  <div className="form-wrapper">
                    <div>
                      <label htmlFor="name">Naam</label>
                      <input type="text" name="name" id="name" value={name} required onChange={this.onChangeTextField} />

                      <label htmlFor="firstName">Voornaam</label>
                      <input type="text" name="firstName" id="firstName" value={firstName} required onChange={this.onChangeTextField} />

                      <label htmlFor="tel">Telefoon</label>
                      <input type="text" name="tel" id="tel" value={tel} required onChange={this.onChangeTextField} />

                      <label htmlFor="email">E-mailadres</label>
                      <input type="email" name="email" id="email" value={email} required onChange={this.onChangeTextField} />

                      <label htmlFor="message">Bericht</label>
                      <textarea name="message" id="message" value={message} required onChange={this.onChangeTextField} />
                    </div>

                    <div className="button-wrapper">
                      <ReCAPTCHA
                        sitekey="6Ld_S8wUAAAAALm5tkK5Rai44vi6l3Pnl0YM4_nC"
                        onChange={this.onChangeReCaptcha}
                        id="hiddenCaptcha"
                      />
                      <button type="submit" className="orange-button">Verzenden</button>
                    </div>
                  </div>
                </form>
              </div>

              {/* Contact info + openingsuren */}
              <div className="contact-info-card">
                <div className="info-section">
                  <h4><FaPhone /> Telefoon</h4>
                  <p>0479 71 04 37<br />09 225 45 14</p>
                </div>

                <div className="info-section">
                  <h4><FaRegEnvelope /> E-mail</h4>
                  <p>tho_vw@hotmail.com</p>
                </div>

                <div className="info-section">
                  <h4><FaMapMarkerAlt /> Adres</h4>
                  <p>Gentweg 26, 9940 Evergem</p>
                </div>

                <div className="info-section">
                  <h4><FaClock /> Openingsuren</h4>
                  <div className="openingsuren-wrapper">
                    <table className="openingsuren-tabel">
                      <tbody>
                        <tr>
                          <td className="dag">Maandag</td>
                          <td className="uren">
                            <div>8u00 – 18u00</div>
                            <div>19u30 – 20u30</div>
                          </td>
                        </tr>
                        <tr>
                          <td className="dag">Dinsdag</td>
                          <td className="uren">
                            <div>8u00 – 18u00</div>
                            <div>19u30 – 20u30</div>
                          </td>
                        </tr>
                        <tr>
                          <td className="dag">Woensdag</td>
                          <td className="uren">
                            <div>8u00 – 18u00</div>
                            <div>19u30 – 20u30</div>
                          </td>
                        </tr>
                        <tr>
                          <td className="dag">Donderdag</td>
                          <td className="uren">
                            <div>8u00 – 18u00</div>
                            <div>19u30 – 20u30</div>
                          </td>
                        </tr>
                        <tr>
                          <td className="dag">Vrijdag</td>
                          <td className="uren">
                            <div>8u00 – 18u00</div>
                          </td>
                        </tr>
                        <tr>
                          <td className="dag">Zaterdag</td>
                          <td className="uren normal">
                            <div>Op afspraak</div>
                          </td>
                        </tr>
                        <tr>
                          <td className="dag">Zondag</td>
                          <td className="uren normal">
                            <div>Gesloten</div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2" className="pauze normal">Middagpauze tussen 12u00 – 13u00</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ContentWrapper>
        </div>
      </div>
    );
  }
}

export default Contact;
